import {format} from 'url';
import {SET_DESTINATION_URGENCY_MEASUREMENTS} from './action-types';
import {getPrefix} from '../utils/urls';

export const setDestinationUrgencyMeasurements = (measurements) => {
    return {
        type: SET_DESTINATION_URGENCY_MEASUREMENTS,
        ...measurements
    };
};

export const fetchDestinationUrgencyMessage = (lbsId) => {
    return (dispatch) => {
        const requestUrl = format({
            pathname: `/${getPrefix()}/api/urgency-message/destination`,
            query: {lbsId}
        });

        return fetch(requestUrl, {
            credentials: 'same-origin'
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(
                        'Failed loading destination urgency messages'
                    );
                }
                return res.json();
            })
            .then((measurements) =>
                dispatch(setDestinationUrgencyMeasurements(measurements))
            )
            .catch((err) => console.log(err)); // eslint-disable-line
    };
};
